import { T, always, cond, equals } from 'ramda'
import { ROLE_BORROWER } from 'src/constants'
import { BORROWER, COBORROWER } from 'src/services/constants'
import * as displayerConst from '../constants'



export const getShowModalTitle = (title: any, loanRole: any) => {
    return `${title} ${equals(loanRole, ROLE_BORROWER) ? BORROWER : COBORROWER}`
}

export const handleShowAllSaver = (upd: any, updateFn: any, dispatch: any) => {
    // const updatedData = pathOr(pathOr('', ['id'], upd), ['data', 'id'], upd)
    return dispatch(updateFn(upd));
};

export const SHOW_VOR = 'ShowAllVORFn'
export const SHOW_VOD = 'ShowAllVODFn'
export const SHOW_VOOA = 'ShowAllVOOAFn'
export const SHOW_VOL = 'ShowAllVOLFn'
export const SHOW_VOOL = 'ShowAllVOOLFn'
export const SHOW_VOE = 'ShowAllVOEFn'
export const SHOW_VOM = 'ShowAllVOMFn'
export const SHOW_OTHER_INCOMES = 'ShowAllOtherIncomesFn'
export const SHOW_VOAL = 'ShowAllVOALFn'
export const SHOW_VOGG = 'ShowAllVOGGFn';
export const SHOW_MORE_COLLATERAL = 'ShowMoreCollaterals';
export const SHOW_FEES_AND_CHARGES = 'ShowFeesAndCharges'
export const SHOW_DISBURSEMENTS = 'ShowDisbursements';



export const showAllFormGroups = (formType: string) => {

    return cond([
        [equals(SHOW_VOR), always([
            displayerConst.DISPLAYER_APPLICANT_CURRENT_ADDRESS,
            displayerConst.DISPLAYER_CURRENT_ADDRESS_LANDLORD,
            displayerConst.DISPLAYER_CURRENT_ADDRESS_FROM,
            displayerConst.DISPLAYER_APPLICANT_FORMER_ADDRESS,
        ])],
        [equals(SHOW_VOAL), always([
            displayerConst.DISPLAYER_OTHERLOANS_POPUP
        ])],
        [equals(SHOW_VOD), always([
            displayerConst.DISPLAYER_ASSETS,
            displayerConst.DISPLAYER_ASSETS_DEPOSITORY,
            displayerConst.DISPLAYER_ASSETS_FROM
        ])],
        [equals(SHOW_VOOA), always([
            displayerConst.DISPLAYER_OTHER_ASSETS,
            displayerConst.DISPLAYER_OTHER_ASSETS_DEPOSITORY,
            displayerConst.DISPLAYER_OTHER_ASSETS_FROM
        ])],
        [equals(SHOW_VOL), always([
            displayerConst.DISPLAYER_LIABILITIES,
            displayerConst.DISPLAYER_LIABILITIES_ACCOUNT_INFO,
            displayerConst.DISPLAYER_LIABILITIES_DEBT_INFORMATION,
            displayerConst.DISPLAYER_LIABILITIES_PAYMENT_HISTORY,
            displayerConst.DISPLAYER_LIABILITIES_NAME_AND_ADDRESS,
            displayerConst.DISPLAYER_LIABILITIES_FROM,
            displayerConst.DISPLAYER_LIABILITIES_ABILITY_TO_REPAY,
        ])],
        [equals(SHOW_VOOL), always([
            displayerConst.DISPLAYER_OTHER_LIABILITIES,
            displayerConst.DISPLAYER_OTHER_LIABILITIES_ACCOUNTINFO,
            displayerConst.DISPLAYER_OTHER_LIABILITIES_NAMEANDADDRESS,
            displayerConst.DISPLAYER_OTHER_LIABILITIES_FROM
        ])],
        [equals(SHOW_VOE), always([
            displayerConst.DISPLAYER_VOE_NAME_AND_ADDRESS,
            displayerConst.DISPLAYER_VOE_EMPLOYMENT_FROM,
            displayerConst.DISPLAYER_VOE_EMPLOYER_INFORMATION,
            displayerConst.DISPLAYER_VOE_EMPLOYMENT,
            displayerConst.DISPLAYER_VOE_EMPLOYER_HISTORY,
            displayerConst.DISPLAYER_VOE_EMPLOYER_GROSSINCOME
        ])],
        [equals(SHOW_VOM), always([
            displayerConst.DISPLAYER_VOM_TABLE_DISPLAYER,
            displayerConst.DISPLAYER_VOM_FROM,
            displayerConst.DISPLAYER_VOM_PROPERTY_INFO_LEFT,
            displayerConst.DISPLAYER_VOM_PROPERTY_INFO_RIGHT
        ])],
        [equals(SHOW_OTHER_INCOMES), always([
            displayerConst.DISPLAYER_OTHER_INCOME_SOURCES,
            displayerConst.DISPLAYER_OTHER_INCOMES_POPUP
        ])],
        [equals(SHOW_VOGG), always([
            displayerConst.DISPLAYER_VOGG_TABLE_DISPLAYER,
            displayerConst.DISPLAYER_VOGG_NAME_AND_ADDRESS,
            displayerConst.DISPLAYER_VOGG_FROM
        ])],
        [equals(SHOW_MORE_COLLATERAL), always([
            displayerConst.DISPLAYER_MORE_COLLATORAL_TABLE_LIST,
            displayerConst.DISPLAYER_MORE_COLLATORAL_INFO,
            displayerConst.DISPLAYER_MORE_COLLATORAL_SECURITY_LIST,
            displayerConst.DISPLAYER_MORE_COLLATORAL_INSURANCE_LIST,
            displayerConst.DISPLAYER_COLLATERAL_REAL_ESTATE_INFO
        ])],
        [equals(displayerConst.DISPLAYER_MORE_COLLATORAL_OWNERS_LIST), always([
            displayerConst.DISPLAYER_MORE_COLLATORAL_OWNERS_LIST
        ])],
        [equals(SHOW_FEES_AND_CHARGES), always([
            displayerConst.DISPLAYER_FEES_AND_CHARGES
        ])],
        [equals(SHOW_DISBURSEMENTS), always([
            displayerConst.DISPLAYER_DISBURSEMENT_INFO
        ])],
        [T, always([])]
    ])(formType)


}